import config from "src/config/config";

let bannerDataPromise: Promise<any> | null = null;

export type SocialMediaLink = {
    url: string;
    label: string;
    icon: string;
    isEnabled: boolean;
};

const hasText = (value: unknown): value is string => typeof value === "string" && value.trim().length > 0;

const trimSocialMediaLink = (link: SocialMediaLink): SocialMediaLink => ({
    ...link,
    url: link.url.trim(),
    label: link.label.trim(),
    icon: link.icon.trim(),
});

const isValidSocialMediaLink = (link: SocialMediaLink): boolean => {
    return (
        link.isEnabled === true &&
        hasText(link.url) &&
        hasText(link.label) &&
        hasText(link.icon)
    );
};

const fetchAllBannerData = async () => {
    if (bannerDataPromise) {
        return bannerDataPromise;
    }

    bannerDataPromise = (async () => {
        try {
            const gqlURL = config.gqlHost || "";
            const fileEnv = gqlURL.includes("bbb365.link") ? "dev" : "prod";

            const response = await fetch(
                `https://pixel.raksahb.com/banner-data/${fileEnv}/banner_data_new_desktop.json`,
                { cache: "no-store" }
            );

            if (!response.ok) {
                console.error(`Failed to fetch banner data: ${response.status}`);
                return null;
            }

            return await response.json();
        } catch (error) {
            bannerDataPromise = null;
            console.error("Error fetching banner data", error);
            return null;
        }
    })();

    return bannerDataPromise;
};

export const fetchBannerData = async (brandId: string) => {
    const data = await fetchAllBannerData();

    const banners = data?.bannersData?.[brandId] ?? [];
    const sortedBannerData = [...banners].sort(
        (a, b) => Number(a.position) - Number(b.position)
    );

    const socialMediaLinks = data?.socialMediaLinks?.[brandId] ?? [];
    const validSocialLinks = socialMediaLinks.filter(isValidSocialMediaLink).map(trimSocialMediaLink);

    return {
        banners: sortedBannerData,
        socialMediaLinks: validSocialLinks,
    };
};